<template>
  <div>
    <div class="web-box top-page">
      <a-row>
        <a-col :xs="24" :sm="12" class="top-left">
          <p>关于我们</p>
          <p>福建微动传媒科技有限公司 - VEDAMOBI</p>
        </a-col>
        <a-col :xs="24" :sm="12">
          <img class="jixiangwu" src="http://www.vedamobi.com/assets/website/images/aboutUs/top.png" />
        </a-col>
      </a-row>
    </div>
    <p class="home-title aboutus-title">公司环境</p>
    <div class="web-box">
      <a-row :gutter="20">
        <a-col :xs="24" :sm="24" :md="24" :xl="10">
          <div class="img-wrap img-wrap1">
            <img src="http://www.vedamobi.com/assets/website/images/aboutUs/premises5.jpg" />
          </div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :xl="14">
          <a-row :gutter="20">
            <a-col :xs="24" :sm="24" :md="24" :xl="12">
              <div class="img-wrap img-wrap2">
                <img src="http://www.vedamobi.com/assets/website/images/aboutUs/premises1.jpg" />
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :xl="12">
              <div class="img-wrap img-wrap3">
                <img src="http://www.vedamobi.com/assets/website/images/aboutUs/premises4.jpg" />
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col :xs="24" :sm="24" :md="24" :xl="10">
              <div class="img-wrap img-wrap4">
                <img src="http://www.vedamobi.com/assets/website/images/aboutUs/premises2.jpg" />
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :xl="14">
              <div class="img-wrap img-wrap5">
                <img src="http://www.vedamobi.com/assets/website/images/aboutUs/premises3.jpg" />
              </div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <p class="home-title aboutus-title">公司概况</p>
      <p class="aboutus-content">
        &emsp;&emsp;福建微动传媒科技有限公司于2021年04月28日成立。服务客户遍及游戏、快消、美容、网红、教育等，我们拥有一支充满活力、积极向上、从业经验丰富的专业团队，秉承“技术创造价值”及“服务至上”的理念，认真对待每一位客户，为客户创造更多价值。
        <br />&emsp;&emsp;公司的经营范围包括：软件开发；互联网信息服务（不含药品信息服务和网吧）；其他未列明科技推广和应用服务业；广告的设计、制作、代理、发布；文化、艺术活动策划；其他未列明文化艺术业；信息技术咨询服务；其他未列明专业技术服务业（不含需经许可审批的事项）；信息系统集成服务；数据处理和存储服务；集成电路设计；互联网接入及相关服务（不含网吧）；其他互联网服务（不含需经许可审批的项目）；会议及展览服务等。
        <!-- <br />&emsp;&emsp;我们于微博2017-2019年的代理商评选中连续三年荣获游戏行业优秀效果类广告代理“金浪奖”。
        <br />&emsp;&emsp;2018年达成的最高日消耗超100万，多次荣获微博“百万之星”奖，单游戏行业在微博消耗接近1亿，是微博游戏行业最佳代理商之一。
        <br />&emsp;&emsp;2018年，微动是网易消耗量最大的代理商，腾讯内容营销部唯一合作微博账号运营超级粉丝通代理商，我们在众多代理中脱颖而出，客户的认可是我们前进的动力。 -->
        <br />&emsp;&emsp;微动注重员工成长，为员工提供良好的工作环境和激励机制；完善员工培养体系，使员工与企业共同进步；充分尊重和信任员工，不断引导和鼓励，使员工更有责任感和归属感；注重长远发展，不因商业因素损害客户利益；关注并深刻理解用户需求，创造良好的互联网环境；重视与客户的沟通，满足客户的需求；不断优化、提升自身技术能力，保护客户隐私，遵纪守法，维护国家尊严。
      </p>
    </div>
  </div>
</template>
<script>
import ScrollReveal from 'scrollreveal'
export default {
  data() {
    return {
      scrollReveal: ScrollReveal()
    }
  },

  mounted() {
    this.scrollReveal.reveal(`.jixiangwu`, {
      duration: 600,
      delay: 0,
      origin: 'right',
      reset: true,
      mobile: false,
      distance: '500px',
      opacity: 0.001,
      easing: 'linear'
    })
    for (const index of [1, 2, 3, 4, 5]) {
      this.scrollReveal.reveal(`.img-wrap${index}`, {
        // 动画的时长
        duration: 500,
        // 延迟时间
        delay: 200 * (index - 1),
        // 回滚的时候是否再次触发动画
        reset: true,
        // 在移动端是否使用动画
        mobile: false,
        // 滚动的距离，单位可以用%，rem等
        scale: 0.5,
        // 其他可用的动画效果
        opacity: 0.001,
        easing: 'linear'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.top-page {
  overflow: hidden;
  padding-top: 180px;
  min-height: 100vh;

  .top-left {
    padding: 0 160px;

    p:nth-child(1) {
      margin-top: 160px;
      font-size: 44px;
    }

    p:nth-child(2) {
      font-size: 22px;
    }
  }

  .jixiangwu {
    width: 600px;
    height: 600px;
  }

  .button-icon {
    font-family: iconFont;
    float: right;
    padding-right: 10px;
  }
}

.aboutus-title {
  margin-top: 100px;
}

.media-wrap {
  max-width: 1300px;
  width: 100%;
  padding: 0 40px;
  margin: 0 auto;

  .explain {
    font-size: 20px;
    line-height: 50px;
  }

  .media-content {
    div {
      flex: 1;
      text-align: center;
      margin-top: 40px;

      .icon {
        font-family: 'iconFont';
        font-size: 100px;
        margin: 0;
      }
    }
  }
}

.aboutus-content {
  font-size: 16px;
  margin-bottom: 200px;
  line-height: 60px;
}

.img-wrap {
  width: 100%;
  overflow: hidden;
  text-align: center;
  border: 12px solid #fff;
  margin-top: 20px;

  img {
    height: 100%;
    transition: 0.6s transform linear;

    &:hover {
      transform: scale(1.3);
    }
  }
}

.img-wrap1 {
  height: 750px;
}

.img-wrap2,
.img-wrap3,
.img-wrap4,
.img-wrap5 {
  height: 365px;
}

@media (max-width: 1200px) {
  .img-wrap {
    img {
      max-width: 100%;
      height: auto;
    }
  }

  .img-wrap1,
  .img-wrap2,
  .img-wrap3,
  .img-wrap4,
  .img-wrap5 {
    height: auto;
  }
}

@media (max-width: 750px) {
  .img-wrap {
    border: 6px solid #fff;
  }

  .aboutus-content {
    font-size: 16px;
    margin-bottom: 200px;
    line-height: 30px;
  }

  .top-page {
    overflow: hidden;
    padding-top: 80px;
    min-height: 100vh;

    .top-left {
      text-align: center;
      padding: 0 20px;

      p:nth-child(1) {
        margin-top: 60px;
        font-size: 24px;
      }

      p:nth-child(2) {
        font-size: 18px;
      }
    }

    .jixiangwu {
      width: 100%;
      height: auto;
    }
  }
}
</style>
